import "./singleReport.css"
import TitleBar from '../titleBar/TitleBar';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { ArrowBack, CheckCircle, Close, InsertChartOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/print/lib/styles/index.css';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';

import { LocalizationMap } from '@react-pdf-viewer/core';

import ru_RU from '@react-pdf-viewer/locales/lib/ru_RU.json';

import workerSrc from 'pdfjs-dist/build/pdf.worker.entry';

const PDFViewer = ({ show, handleClick, report, apartmentId }) => {
    const { DocumentURL } = report
    const toolbarPluginInstance = toolbarPlugin();
    const { renderDefaultToolbar, Toolbar } = toolbarPluginInstance;
    const pageNavigationPluginInstance = pageNavigationPlugin();
    const transform = (slot) => ({
        ...slot,
        EnterFullScreen: () => <></>,
        EnterFullScreenMenuItem: () => <></>,
        SwitchTheme: () => <></>,
        SwitchThemeMenuItem: () => <></>,
        Open: () => <></>,
        GoToNextPage: () => <></>,
        GoToNextPageMenuItem: () => <></>,
        GoToPreviousPage: () => <></>,
        GoToPreviousPageMenuItem: () => <></>,
        NumberOfPages: () => <></>,
        CurrentPageInput: () => <></>,

    });
    return (
        <>
            <TitleBar title='Отчеты'
                arrow={
                    <IconButton component={Link} to={`/apartments/${apartmentId}/reports`}>
                        <ArrowBack />
                    </IconButton>}
                icon={
                    <InsertChartOutlined color="primary" fontSize="large" sx={{ m: '0 10px 0' }} />
                }
            />
            <Box sx={{display: "flex", justifyContent: 'center', flexDirection: "column", flexGrow: "0", alignItems: "center"}}>
                <Button
                    variant='contained'
                    onClick={() => {
                        handleClick()
                    }}
                >Принять</Button>
                {show ? (
                    <Button 
                        sx={{position: "absolute", zIndex: 1, mt: 25, width: '250px', textTransform: 'none', bgcolor: 'rgba(226, 236, 245, 1)' }}
                        startIcon={<CheckCircle />}
                        endIcon={<Close />}
                        onClick={handleClick}
                    >
                        <Typography>Отчет принят</Typography>
                    </Button>
                ) : null}
            </Box>
            <div className="viewPdfDiv">
                <Worker workerUrl={workerSrc}>
                    <div
                        style={{
                            border: '1px solid rgba(0, 0, 0, 0.3)',
                            width: "100%",
                            height: "100%"
                        }}
                    >
                        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
                        <Viewer plugins={[toolbarPluginInstance, pageNavigationPluginInstance]} fileUrl={`${DocumentURL}`} defaultScale={SpecialZoomLevel.PageWidth}/>
                    </div>
                </Worker>
                {/* <embed className="pdfete" src={DocumentURL} type="application/pdf" /> */}
            </div>
        </>
    );
}

export default PDFViewer;
